import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Dialog, Input, InputAdornment, MessagePlugin, Select, Textarea } from 'tdesign-react';
import { confirmPwd, createHost } from '@/services/resourceService';
import Tip from '@/components/Tip';
import { toTsOptions } from '@/utils/common';
import Form from '@/components/Form';
import ConformPwd from '../ConfirmPwd';

const { FormItem } = Form;

function FormModal({ visible, handleClose, clusterId, clusters }) {
  const [form] = Form.useForm();
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const formValues = Form.useWatch([], form);

  useEffect(() => {
    if (visible) {
      form.setFieldValue('hostName', clusterId);
    } else {
      form.resetFields();
    }
  }, [visible, form, clusterId]);

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      const { data } = await createHost({
        opsClusterId: clusterId,
        ...values,
      });
      if (data.isVerified === 'NO') {
        setConfirmVisible(true);
        return;
      }

      MessagePlugin.info('操作成功');
      handleClose(true);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  const confirmClose = async (values) => {
    setConfirmVisible(false);
    if (values) {
      try {
        setSubmitting(true);
        await confirmPwd({
          opsClusterId: clusterId,
          ...formValues,
          ...values,
        });

        MessagePlugin.info('操作成功');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <>
      <Dialog
        header={'新建主机'}
        visible={visible}
        onClose={() => handleClose()}
        onConfirm={() => form.submit()}
        confirmBtn={{ loading: submitting, content: '确定' }}
        placement='center'
        destroyOnClose
        width={686}
      >
        <Root>
          <Form form={form} onFinish={handleSubmit} style={{ width: '90%' }}>
            <FormItem name='hostName' label='所属集群' rules={[{ required: true }]}>
              <Select options={toTsOptions(clusters)} filterable />
            </FormItem>
            <FormItem label='IP地址' requiredMark>
              <FormItem name='hostUser' rules={[{ required: true, message: '请输入用户名' }]}>
                <InputAdornment prepend='ssh'>
                  <Input placeholder='用户名' style={{ width: 83 }} />
                </InputAdornment>
              </FormItem>
              <FormItem name='hostIp' rules={[{ required: true, message: '请输入主机/IP' }]}>
                <InputAdornment prepend='@'>
                  <Input placeholder='主机/IP' style={{ width: 140 }} />
                </InputAdornment>
              </FormItem>
              <FormItem name='hostPort' rules={[{ required: true, message: '请输入端口' }]}>
                <InputAdornment prepend='-p'>
                  <Input placeholder='端口' style={{ width: 83 }} />
                </InputAdornment>
              </FormItem>
            </FormItem>
            <FormItem
              name='serviceIp'
              label={
                <Tip
                  align='right'
                  content='对外提供的ip地址，用于单机多IP的情况，默认为上面的IP地址'
                >
                  服务地址
                </Tip>
              }
            >
              <Input />
            </FormItem>
            <FormItem name='desc' label='主机描述'>
              <Textarea placeholder='主机描述' />
            </FormItem>
          </Form>
        </Root>
      </Dialog>
      <ConformPwd visible={confirmVisible} handleClose={confirmClose} />
    </>
  );
}

export default connect((state) => ({
  clusters: state.resource.clusters
    .filter((item) => item.type === 0)
    .map((item) => ({
      label: item.name,
      value: item.id,
    })),
}))(FormModal);

const Root = styled.div`
  .t-input-adornment__text {
    white-space: nowrap;
  }
`;
